import React from "react";
import img from "../../Resources/svg/icon-back.svg";

const Step = ({step, total, handleClick}: any) => {
  return (
    <div className="steps">
      <a className="steps__link" onClick={() => handleClick()}>
        <img src={img}/>
      </a>
      <div className="steps__text">
        <span className="steps__text__bold">Paso {step}</span> de {total}
      </div>
    </div>
  );
};

export default Step;